export const blockIconsActionSettings = (
	<span className='material-symbols-outlined'>settings</span>
);
